module.exports = __webpack_public_path__ + "21bacf5ec5f20f39ec6b76cc0e7c273c.svg";